import React from 'react'
import { Theme, useTheme } from '@mui/material'

interface IIconProps {
  width?: string
}

const PerfectIcon: React.FC<IIconProps> = (props) => {
  const theme: Theme = useTheme()
  return (
    <svg
      id='fi_2165867' enable-background='new 0 0 496 496' viewBox='0 0 496 496' fill={theme.palette.text.primary}
      height={props.width} width={props.width}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='m412.754 108.37c0 4.904 3.443-9.414-46.04 175.22-2.742-10.635-1.92 12.37-1.92-189.57 14.204-21.63 47.96-11.422 47.96 14.35z'
      />
      <path
        d='m348.794 30.4v217.62c-58.22-100.822-32.549-56.388-60.8-105.32v-112.3c0-16.76 13.64-30.4 30.4-30.4 17.021 0 30.4 13.796 30.4 30.4z'
      />
      <path
        d='m313.644 219.13-23.6-23.59c-20.547-20.556-47.57-32.34-79.78-32.34l-53.92-89.92c-8.319-14.455-3.452-33.047 11.15-41.48 14.687-8.469 33.219-3.253 41.53 11.13 82.258 136.705 40.162 64.55 104.62 176.2z'
      />
      <path
        d='m357.194 334.59c0 49.94-19.858 98.078-55.33 133.58-17.31 17.29-40.3 27.17-64.74 27.8-3.894 0 14.988.03-42.46.03-61.46 0-111.47-50-111.47-111.47v-153.6c0-5 4.07-9.06 9.07-9.06.784 0 1.428-.045 2.39-.31 2.491.989 24.983.646 40.2 22.67 9.828 13.131 9.14 28.427 9.14 37.9 0 34.23 14.78 66.78 40.53 89.33 27.886 24.409 71.51 4.393 71.51-32.45-.01-40.907 1.562-50.335-5.56-66.5-6.373-14.399-14.392-20.616-25.14-30.42-3.658-2.93.855-2.09-74.28-2.09-9.903-17.607-28.483-30.951-50.62-33.63.9-8.609 5.523-16.828 13.43-22.11 13.152-6.416-1.531-5.06 98.12-5.06 25.21 0 48.92 9.82 66.75 27.65l65.83 65.83 4.98 8.63c4.666 17.141 7.65 32.916 7.65 53.28z'
      />
    </svg>
  )
}
export default PerfectIcon
